import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { FeaturesPage } from './pages/FeaturesPage';
import { PricingPage } from './pages/PricingPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { EULAPage } from './pages/EULAPage';
import { SecurityPolicyPage } from './pages/SecurityPolicyPage';
import { GettingStartedPage } from './pages/guides/GettingStartedPage';
import { UnderstandingFlowHealthScoresPage } from './pages/guides/UnderstandingFlowHealthScoresPage';
import { ImplementingAiRecommendationsPage } from './pages/guides/ImplementingAiRecommendationsPage';
import { AgencyWhiteLabelSetupPage } from './pages/guides/AgencyWhiteLabelSetupPage';
import { HelpPage } from './pages/HelpPage';
import { HelpArticlePage } from './pages/HelpArticlePage';
function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/features" element={<FeaturesPage data-id="element-6" />} data-id="element-5" />
          <Route path="/pricing" element={<PricingPage data-id="element-8" />} data-id="element-7" />
          <Route path="/resources" element={<ResourcesPage data-id="element-10" />} data-id="element-9" />
          <Route path="/help" element={<HelpPage data-id="element-12" />} data-id="element-11" />
          <Route path="/help/:slug" element={<HelpArticlePage data-id="element-14" />} data-id="element-13" />
          <Route path="/about" element={<AboutPage data-id="element-16" />} data-id="element-15" />
          <Route path="/contact" element={<ContactPage data-id="element-18" />} data-id="element-17" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-20" />} data-id="element-19" />
          <Route path="/terms" element={<TermsPage data-id="element-22" />} data-id="element-21" />
          <Route path="/eula" element={<EULAPage data-id="element-24" />} data-id="element-23" />
          <Route path="/security" element={<SecurityPolicyPage data-id="element-26" />} data-id="element-25" />
          <Route path="/guides/getting-started" element={<GettingStartedPage data-id="element-28" />} data-id="element-27" />
          <Route path="/guides/understanding-flow-health-scores" element={<UnderstandingFlowHealthScoresPage data-id="element-30" />} data-id="element-29" />
          <Route path="/guides/implementing-ai-recommendations" element={<ImplementingAiRecommendationsPage data-id="element-32" />} data-id="element-31" />
          <Route path="/guides/agency-white-label-setup" element={<AgencyWhiteLabelSetupPage data-id="element-34" />} data-id="element-33" />
        </Routes>
      </Layout>
    </Router>;
}
export { App };